exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.alert-dialog__header-inner[data-v-639e6d93] {\n  width: 100%;\n  position: relative;\n  text-align: center;\n}\n.alert-dialog__title[data-v-639e6d93] {\n  display: inline-block;\n  padding: 0 28px;\n}\n.alert-dialog__close[data-v-639e6d93] {\n  position: absolute;\n  top: -10px;\n  right: -15px;\n  margin: 0;\n}\n", ""]);

// exports
